import { render, staticRenderFns } from "./D2CDrawerCustomiseCoverContentValuables.vue?vue&type=template&id=4a700fb6&scoped=true&"
import script from "./D2CDrawerCustomiseCoverContentValuables.vue?vue&type=script&lang=js&"
export * from "./D2CDrawerCustomiseCoverContentValuables.vue?vue&type=script&lang=js&"
import style0 from "./D2CDrawerCustomiseCoverContentValuables.vue?vue&type=style&index=0&id=4a700fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a700fb6",
  null
  
)

export default component.exports